module.exports = __webpack_public_path__ + "static/media/arrows-to-left.1331ed65.svg";